const getQueryErrorDeauthorization = (): string => {
  return "Ошибка при отправке запроса. Необходимо повторно пройти процедуру авторизации";
};

export default getQueryErrorDeauthorization;
